import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import * as serviceWorker from "./serviceWorker";
import Routes from "./router/Routes";
import { BrowserRouter as Router } from "react-router-dom";
import "./themes/css/list-view.css";
import "./themes/css/railways-login.css";
import App from "./App";
import { useMsal } from "@azure/msal-react";
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { msalConfig } from "./components/Authentication";
import axios from "axios";
import Apiservices from "./common"; // Adjust if needed


const msalInstance = new PublicClientApplication(msalConfig);

// Axios interceptor to handle 401 errors
axios.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        if (error.response && error.response.status === 401) {
            window.location.reload(true);
            sessionStorage.clear(); // Clear session storage
            // Trigger MSAL logout redirect
            // const { instance } = useMsal();
            // instance.logoutRedirect({
            //     postLogoutRedirectUri: "/railways",
            // });
        }
        return Promise.reject(error);
    }
);

ReactDOM.render(
    <React.StrictMode>
        <Router>
            <MsalProvider instance={msalInstance}>
                <App />
            </MsalProvider>
        </Router>
    </React.StrictMode>,
    document.getElementById("root")
);

serviceWorker.unregister();
